import {
  getToken,
  setToken,
  toQueryString,
  serializeObject,
  get,
  post,
  del,
  put,
  serializeObjectEnhanced
} from './fetch';
import _ from './l10n';
import * as jwtDecode from 'jwt-decode';
import * as moment from 'moment';

export { getToken, setToken, toQueryString, serializeObject, serializeObjectEnhanced };

export interface IProfile {
  email: string;
  token: string;
}
export interface ISession {
  user: IProfile;
}

export interface IAccessToken {
  aud: string;
  exp: number;
  firstname: string;
  iat: number;
  iss: string;
  lang: string;
  lastname: string;
  nbf: number;
  roles: string;
  sub: string;
}

export const order ={
  getOrderById: (orderId) =>{ 
    let response  = get('/Rbc/'+ orderId);
    return response;
  }
}


export const registration ={
  signup: (state) =>{     
    let response  = post('/Registration/Signup', state);
    return response;
  },

  setPassword: (state) =>{ 
    console.log("setPassword in api:");
    console.log(state);
    let response  = post('/Registration/SetPassword', state);
    return response;
  },

  getFirms: (state) =>{ 
    let response  =  get('/SelfServe/FirmsInfo');
    console.log("test");
    console.log(response);
    return response;
  },

  getMembers: (vendorId) =>{ 
    let response  =  get('/SelfServe/Members/'+ vendorId);
    return response;
  },

  getAgreements: (vendorId) =>{ 
    let response  =  get('/SelfServe/Agreements/'+ vendorId);
    return response;
  },

  getContracts: (agreementId) =>{ 
    let response  =  get('/SelfServe/Contracts/'+ agreementId);
    return response;
  },

  getContractDetails: (agreementId) =>{ 
    let response  =  get('/SelfServe/ContractDetails/'+ agreementId);
    return response;
  },

  getMessages: () =>{ 
    let response  =  get('/Content/GetMessage/-1');
    return response;
  },

  readMessages: (messageId) =>{ 
    let response  =  get('/Content/ReadMessage/'+ messageId + '/-1');
    return response;
  },

  deleteMessages: (messageId) =>{ 
    let response  =  get('/Content/DeleteMessage/'+ messageId + '/-1');
    return response;
  },


  addMember: (state) =>{     
    console.log("addMember in api:");
    console.log(state);
    let response  = post('/SelfServe/AddMember', state);
    return response;
  },


}

export const validator ={
  isEmpty: (s) => {
    let ret = true;
    if(s)
        ret = false;

    return ret;
  },

  isValidEmail: (email) =>{
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  },

  isValidPostalCode: (postalCode) =>{
    var re = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i;
    return re.test(String(postalCode).toUpperCase());
  }
}


export const auth = {
  current: () => (getToken() ? get<ISession>('/user') : null),
  signIn: (user: { email: string; password: string }) => post<ISession>('/users/login', { user }),

  save: user => put('/user', { user }),
  refreshToken: () => {
    return get('/users/refreshJWT');
  }
};

export const referralSearch = {
  search: async (searchTerm): Promise<any> => {
    return get('/referralsearch/' + searchTerm);
  },

  searchByType: async (searchTerm, type, id): Promise<any> => {
    let res = await get('/referralsearch/' + type + '/' + searchTerm + '/' + id);
    //console.log(res);
    return res;
  },

  getPersonDetails: async (companyPersonID, langCt): Promise<any> => {
    let res = await get('/rfpersondetails/' + companyPersonID + '/' + langCt);
    return res;
  }
};

export const authorization = {
  isAuthorized: () => {
    if (!window.localStorage) return false;

    let access_token: string = (window && window.localStorage && window.localStorage.getItem('jwt')) || '';
    if (!access_token) return false;
    try {
      let access_token_expiry = jwtDecode<IAccessToken>(access_token).exp;
      //let second_to_expire = access_token_expiry - moment().unix();
      if (moment().unix() > access_token_expiry) return false;
    } catch (error) {
      return false;
    }
    return true;
  },

  loginWithJWT: async (): Promise<IAccessToken> => {
    if (authorization.isAuthorized()) {
      return auth.refreshToken();
    }
    // return Promise.resolve(null);
    return null;
  }
};

export const AccessToken = {
  getUserFromJWT: () => {
    let user: IAccessToken;
    let access_token: string = (window && window.localStorage && window.localStorage.getItem('jwt')) || '';
    if (!access_token) return null;
    try {
      user = jwtDecode<IAccessToken>(access_token);
    } catch (error) {
      return null;
    }
    return user;
  }
};

export async function doSSO(partnerId, partnerUrl, lang) {
  console.log('In doSSO');
  switch (partnerId) {
    case 'LA':
    case 'LL':
    case 'RM':
      const result = await get('/sso/jwt/' + partnerId + '/' + lang);
      console.log({ token: result });
      window.open(partnerUrl + '?token=' + result + ' ', '_Blank');
      break;
    case 'JUMP':
    case 'CARRIAGETRADE':
    case 'JUMPREPORTS':
    case 'JUMPLE':
    case 'SMARTSTUDIO':
    case 'JUMPQR':
    case 'CLIENTCLICK':
    case 'JUMPCREATECOMMERCIAL':
    case 'JUMPCREATEINVESTMENT':
    case 'JUMPCREATEVACANT':
    case 'JUMPCREATEFARM':
    case 'COMMERCIALPROPERTIESWANTED':
    case 'PR':
      window.open(`${window['defaultBasePath']}/sso/xml/${partnerId}/${lang}?t=${getToken()}`, '_Blank');
      break;
    case 'JLR':
      let jlrLang = lang == '1' ? 'fr' : 'en';
      window.open(`${window['defaultBasePath']}/sso/${partnerId}/${jlrLang}?t=${getToken()}`, '_Blank');
      break;
  }


 
  
}
